import { StrategyRequestOrderType } from "./strategy-request-order-type.enum";
import { StrategyRequestLegPriceType } from "./strategy-request-leg-price-type.enum";
import { StrategyRequestLegValidityType } from "./strategy-request-leg-validity-type.enum";
import { OrderSideEnum } from "../../enum/orders/side.enum";
import { VirtualTypeEnum } from "../../enum/orders/virtual-type.enum";
import { OrderOriginTypeEnum } from "../../enum/orders/origin-type.enum";

export class StockOrderType {
    id: string;
    symbol: string;
    price: number;
    internalOrderType: StrategyRequestOrderType; //Tipo da ordem =  Enum StrategyRequestOrderType
    priceType: StrategyRequestLegPriceType; //Tipo do preço = Enum StrategyRequestLegPriceType
    validityType: StrategyRequestLegValidityType; //Tipo da validade da Ordem = Enum StrategyRequestLegValidityType
    orderQty: number;
    side: OrderSideEnum; //Lado da Operação = ['Compra', 'Venda']
    expirationDate: Date;
    isDaytrade: boolean;
    paramGain: number;
    paramLoss: number;
    virtualType: VirtualTypeEnum;
    originType: OrderOriginTypeEnum;
    suitabilityNonConformityConsent?: boolean;
}
